class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.id;
    this.init();

  }
  init() {
    var id = this.id;
    this.querySelector("button").addEventListener("click", async function (event) {
      event.target.classList.add("is-loading");

      // 加购
      var addCart = await fetch(`${window.theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });

      if (addCart.ok) {
        window.location.href = "/cart";
      } else {
        event.target.classList.remove("is-loading");
        console.error("error");
      }

    })

  }
}

if (!customElements.get('buy-now')) {
  customElements.define('buy-now', BuyNow);;
}


class CheckoutBtn extends HTMLElement {
  constructor() {
    super();
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.init();
  }

  /** 监听哪些属性 */
  static get observedAttributes() {
    return ['data-id', 'data-number', 'data-available'];
  }

  /** 属性变化时触发 */
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    if (name === 'data-id') {
      this.id = Number(newValue);
    }

    if (name === 'data-number') {
      this.number = Number(newValue);
    }

    if (name === 'data-available') {
      this.setDisabled(newValue !== 'true');
    }
  }

  connectedCallback() {
    this.eventScope = this.closest('[data-quick-add-modal], [data-section-type]') || document;
    this.eventScope.addEventListener('quantity:change', this.onQuantityChange);
    this.eventScope.addEventListener('theme:variant:change', this.onVariantChange);
    // 初始读取一次
    this.id = Number(this.dataset.id);
    this.number = Number(this.dataset.number);
    this.setDisabled(this.dataset.available === 'false');
  }
  disconnectedCallback() {
    this.eventScope?.removeEventListener('quantity:change', this.onQuantityChange);
    this.eventScope?.removeEventListener('theme:variant:change', this.onVariantChange);
  }
  onQuantityChange(e) {
    const { id, number } = e.detail;
    if (id) {
      this.dataset.id = id;
    }
    if (number) {
      this.dataset.number = number;
    }

  };
  onVariantChange(e) {
    const variant = e.detail?.variant;

    if (variant?.id) {
      this.dataset.id = variant.id;
    }

    this.dataset.available = variant?.available ? 'true' : 'false';
  }
  setDisabled(disabled) {
    this.isDisabled = Boolean(disabled);
    this.classList.toggle('is-disabled', this.isDisabled);
    this.setAttribute('aria-disabled', String(this.isDisabled));

    if (this.isDisabled) {
      this.setAttribute('tabindex', '-1');
    } else {
      this.removeAttribute('tabindex');
    }
  }
  init() {
    this.addEventListener('click', async (event) => {
      if (this.isDisabled || !this.id || !this.number) {
        event.preventDefault();
        return;
      }

      this.classList.add('is-loading');

      try {
        const res = await fetch(`${window.theme.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: this.id,
            quantity: this.number
          })
        });

        if (!res.ok) throw new Error('Add cart failed');

        window.location.href = `/cart/${this.id}:${this.number}`;
      } catch (err) {
        console.error(err);
        this.classList.remove('is-loading');
      }
    });
  }
}

if (!customElements.get('checkout-btn')) {
  customElements.define('checkout-btn', CheckoutBtn);
}

class OptionTitle extends HTMLElement {
  constructor() {
    super();
    this.onToggle = this.onToggle.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  static get observedAttributes() {
    return ['data-value'];
  }

  connectedCallback() {
    this.render();
    this.addEventListener('click', this.onToggle);
    this.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onToggle);
    this.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('click', this.onDocumentClick);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || name !== 'data-value') return;
    this.render();
  }

  get values() {
    try {
      const data = JSON.parse(this.dataset.value || '[]');
      return Array.isArray(data) ? data.filter((item) => item && item.value) : [];
    } catch (error) {
      console.error('Option title data parse failed:', error);
      return [];
    }
  }

  render() {
    const values = this.values;
    const text = values.map((item) => item.value).filter(Boolean).join('/');

    let title = this.querySelector(':scope > span');
    if (!title) {
      title = document.createElement('span');
      title.className = 'title-text';
      this.prepend(title);
    }
    title.textContent = text;

    let info = this.querySelector(':scope > .sticky-hover-info');
    if (!info) {
      info = document.createElement('div');
      info.className = 'sticky-hover-info';
      this.append(info);
    }

    info.innerHTML = values.map((item) => {
      return '<div class="sticky-hover-info__row">' + this.escapeHtml(item.name) + ': ' + this.escapeHtml(item.value) + '</div>';
    }).join('');
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  open() {
    this.classList.add('is-sticky-info-open');
    this.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-sticky-info-open');
    this.setAttribute('aria-expanded', 'false');
  }

  onToggle(event) {
    event.stopPropagation();
    this.classList.contains('is-sticky-info-open') ? this.close() : this.open();
  }

  onKeydown(event) {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      this.onToggle(event);
    }

    if (event.code === 'Escape') {
      this.close();
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }
}

if (!customElements.get('option-title')) {
  customElements.define('option-title', OptionTitle);
}



class VariantScroll extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this;
    this.container = this.querySelector('[data-variant-buttons]');
    this.scrollbar = this.querySelector('[data-variant-scrollbar]');
    this.isQuickColorOptions = this.hasAttribute('data-quick-color-options');
    this.isStaticLayout = this.hasAttribute('data-static-layout');

    // 状态
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.startTranslate = 0;
    this.isHorizontalDrag = null;

    this.velocity = 0;
    this.lastX = 0;
    this.lastTime = 0;

    this.currentTranslate = 0;

    if (!this.isQuickColorOptions && !this.isStaticLayout) {
      this.bindEvents();
    }
  }

  // ===== 绑定事件 =====
  bindEvents() {
    this.startDrag = this.startDrag.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.endDrag = this.endDrag.bind(this);
    this.onOptionChange = this.onOptionChange.bind(this);
    this.onScrollbarInput = this.onScrollbarInput.bind(this);
    this.stopScrollbarDragPropagation = this.stopScrollbarDragPropagation.bind(this);
    this.updateScrollbar = this.updateScrollbar.bind(this);

    this.wrapper.addEventListener('mousedown', this.startDrag);
    this.wrapper.addEventListener('touchstart', this.startDrag, { passive: true });
    this.wrapper.addEventListener('change', this.onOptionChange);

    if (this.scrollbar) {
      this.scrollbar.addEventListener('input', this.onScrollbarInput);
      this.scrollbar.addEventListener('mousedown', this.stopScrollbarDragPropagation);
      this.scrollbar.addEventListener('touchstart', this.stopScrollbarDragPropagation, { passive: true });
    }

    window.addEventListener('mousemove', this.onDrag);
    window.addEventListener('touchmove', this.onDrag, { passive: false });

    window.addEventListener('mouseup', this.endDrag);
    window.addEventListener('mouseleave', this.endDrag);
    window.addEventListener('touchend', this.endDrag);
    window.addEventListener('resize', this.updateScrollbar);

    requestAnimationFrame(() => {
      this.scrollCheckedIntoView(false);
      this.updateScrollbar();
    });
  }

  // ===== translate =====
  getTranslate() {
    return this.currentTranslate;
  }

  setTranslate(x) {
    this.currentTranslate = x;
    this.container.style.transform = `translateX(${x}px)`;
    this.updateScrollbar();
  }

  onScrollbarInput(event) {
    const { min } = this.getBounds();
    const progress = Number(event.target.value) / 100;
    this.container.style.transition = 'none';
    this.setTranslate(min < 0 ? min * progress : 0);
  }

  stopScrollbarDragPropagation(event) {
    event.stopPropagation();
  }

  updateScrollbar() {
    if (!this.scrollbar) return;

    const { min } = this.getBounds();
    const hasOverflow = min < -1;
    this.scrollbar.hidden = !hasOverflow;

    if (!hasOverflow) {
      this.scrollbar.value = 0;
      return;
    }

    const clampedTranslate = Math.max(min, Math.min(0, this.getTranslate()));
    this.scrollbar.value = String((clampedTranslate / min) * 100);
  }

  // ===== 选中项进入视窗 =====
  onOptionChange(e) {
    if (!e.target.matches('input[type="radio"]')) return;

    requestAnimationFrame(() => {
      this.scrollCheckedIntoView(true);
    });
  }

  scrollCheckedIntoView(animate = true) {
    const checked = this.container.querySelector('input[type="radio"]:checked');
    const item = checked && checked.closest('.radio__button');
    if (!item) return;

    const padding = 8;
    const wrapperWidth = this.wrapper.offsetWidth;
    const visibleLeft = -this.getTranslate();
    const visibleRight = visibleLeft + wrapperWidth;
    const itemLeft = item.offsetLeft;
    const itemRight = itemLeft + item.offsetWidth;

    let target = this.getTranslate();

    if (itemLeft < visibleLeft + padding) {
      target = -(itemLeft - padding);
    } else if (itemRight > visibleRight - padding) {
      target = -(itemRight - wrapperWidth + padding);
    } else {
      return;
    }

    const { min, max } = this.getBounds();

    if (target > max) target = max;
    if (target < min) target = min;

    this.container.style.transition = animate
      ? 'transform 0.35s cubic-bezier(0.22, 1, 0.36, 1)'
      : 'none';

    this.setTranslate(target);
  }

  // ===== 边界 =====
  getBounds() {
    const wrapperWidth = this.wrapper.offsetWidth;
    const contentWidth = this.container.scrollWidth;

    return {
      max: 0,
      min: wrapperWidth - contentWidth
    };
  }

  // ===== 每页 =====
  getPageWidth() {
    return this.wrapper.offsetWidth;
  }

  // ===== 开始拖 =====
  startDrag(e) {
    if (this.getBounds().min >= -1) return;

    this.isDragging = true;

    this.startX = this.getX(e);
    this.startY = this.getY(e);
    this.startTranslate = this.getTranslate();
    this.isHorizontalDrag = null;

    this.container.style.transition = 'none';

    this.velocity = 0;
    this.lastX = this.startX;
    this.lastTime = Date.now();
  }

  // ===== 拖动 =====
  onDrag(e) {
    if (!this.isDragging) return;

    const x = this.getX(e);
    const dx = x - this.startX;

    if (e.type.includes('touch')) {
      const y = this.getY(e);
      const dy = y - this.startY;

      if (this.isHorizontalDrag === null && Math.max(Math.abs(dx), Math.abs(dy)) > 5) {
        this.isHorizontalDrag = Math.abs(dx) > Math.abs(dy);
      }

      if (!this.isHorizontalDrag) return;

      e.preventDefault();
    }

    let next = this.startTranslate + dx;

    const { max, min } = this.getBounds();

    // 橡皮筋
    if (next > max) {
      next = max + (next - max) * 0.35;
    } else if (next < min) {
      next = min + (next - min) * 0.35;
    }

    this.setTranslate(next);

    // 速度
    const now = Date.now();
    const dt = now - this.lastTime || 16;

    const v = (x - this.lastX) / dt;
    this.velocity = this.velocity * 0.8 + v * 0.2;

    this.lastX = x;
    this.lastTime = now;
  }

  // ===== 结束 =====
  endDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;

    const pageWidth = this.getPageWidth();
    const { min, max } = this.getBounds();

    // 惯性
    let momentum = this.velocity * 500;
    let final = this.getTranslate() + momentum;

    let page = Math.round(Math.abs(final) / pageWidth);

    // 速度触发翻页（Swiper关键）
    const velocityThreshold = 0.25;

    if (Math.abs(this.velocity) > velocityThreshold) {
      if (this.velocity < 0) page += 1;
      else page -= 1;
    }

    const maxPage = Math.ceil(this.container.scrollWidth / pageWidth) - 1;

    if (page < 0) page = 0;
    if (page > maxPage) page = maxPage;

    let target = -page * pageWidth;

    if (target > max) target = max;
    if (target < min) target = min;

    // 动画（Swiper手感）
    this.container.style.transition =
      'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)';

    this.setTranslate(target);
  }

  // ===== 工具 =====
  getX(e) {
    return e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
  }

  getY(e) {
    return e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
  }

  // ===== 销毁（可选）=====
  disconnectedCallback() {
    if (this.isQuickColorOptions || this.isStaticLayout) return;

    this.wrapper.removeEventListener('mousedown', this.startDrag);
    this.wrapper.removeEventListener('touchstart', this.startDrag);
    this.wrapper.removeEventListener('change', this.onOptionChange);

    if (this.scrollbar) {
      this.scrollbar.removeEventListener('input', this.onScrollbarInput);
      this.scrollbar.removeEventListener('mousedown', this.stopScrollbarDragPropagation);
      this.scrollbar.removeEventListener('touchstart', this.stopScrollbarDragPropagation);
    }

    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('touchmove', this.onDrag);

    window.removeEventListener('mouseup', this.endDrag);
    window.removeEventListener('mouseleave', this.endDrag);
    window.removeEventListener('touchend', this.endDrag);
    window.removeEventListener('resize', this.updateScrollbar);
  }
}

if (!customElements.get('variant-scroll')) {
  customElements.define('variant-scroll', VariantScroll);
}

(function () {
  if (window.GooGooQuickColorOptions) return;

  function toggleQuickColorOptions(button) {
    const options = button.closest('[data-quick-color-options]');
    if (!options) return;

    const isExpanded = options.classList.toggle('is-expanded');
    options.classList.toggle('is-collapsed', !isExpanded);
    button.setAttribute('aria-expanded', String(isExpanded));

    const text = button.querySelector('[data-quick-color-more-text]');
    if (text) text.textContent = isExpanded ? 'Less' : 'More';
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-quick-color-more]');
    if (!button) return;

    event.preventDefault();
    toggleQuickColorOptions(button);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-quick-color-options] input[type="radio"]')) return;

    const options = event.target.closest('[data-quick-color-options]');
    if (!options) return;

    options.querySelectorAll('.radio__button.is-current').forEach(function (item) {
      item.classList.remove('is-current');
    });

    const item = event.target.closest('.radio__button');
    if (item) item.classList.add('is-current');
  });

  window.GooGooQuickColorOptions = true;
})();

(function () {
  function initMobileMenuNavigation(root) {
    if (!root || root.dataset.mobileMenuNavigationReady === 'true') return;

    root.dataset.mobileMenuNavigationReady = 'true';

    var menuLayout = root.closest('.mobile-drawer-new');
    var scrollContainer =
      menuLayout?.querySelector('.drawer-content-new') ||
      root.closest('.drawer__content__scroll');
    var leftNavigation = root.closest('.mobile-header-nav');
    var scrollFrame = null;

    function setActiveAnchor(anchorButton, keepVisible) {
      if (!anchorButton || anchorButton.classList.contains('is-active')) return;

      root.querySelectorAll('[data-mobile-menu-anchor].is-active').forEach(function (button) {
        button.classList.remove('is-active');
      });
      anchorButton.classList.add('is-active');

      if (!keepVisible || !leftNavigation) return;

      var navigationRect = leftNavigation.getBoundingClientRect();
      var anchorRect = anchorButton.getBoundingClientRect();

      if (anchorRect.top < navigationRect.top) {
        leftNavigation.scrollTop -= navigationRect.top - anchorRect.top;
      } else if (anchorRect.bottom > navigationRect.bottom) {
        leftNavigation.scrollTop += anchorRect.bottom - navigationRect.bottom;
      }
    }

    function syncActiveAnchorFromScroll() {
      scrollFrame = null;
      if (!scrollContainer) return;

      var activePanel = Array.from(scrollContainer.children).find(function (panel) {
        return panel.classList.contains('uk-active');
      });
      if (!activePanel) return;

      var sections = Array.from(activePanel.querySelectorAll('[data-mobile-menu-section]'));
      if (!sections.length) return;

      var currentSection = sections[0];
      var containerRect = scrollContainer.getBoundingClientRect();
      var activationLine = containerRect.top + Math.min(40, scrollContainer.clientHeight * 0.15);
      var isAtBottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 2;

      if (isAtBottom) {
        currentSection = sections[sections.length - 1];
      } else {
        sections.forEach(function (section) {
          if (section.getBoundingClientRect().top <= activationLine) {
            currentSection = section;
          }
        });
      }

      var matchingAnchor = Array.from(root.querySelectorAll('[data-mobile-menu-anchor]')).find(
        function (button) {
          return button.getAttribute('data-mobile-menu-anchor') === currentSection.id;
        }
      );

      setActiveAnchor(matchingAnchor, true);
    }

    if (scrollContainer) {
      scrollContainer.addEventListener(
        'scroll',
        function () {
          if (scrollFrame) return;
          scrollFrame = requestAnimationFrame(syncActiveAnchorFromScroll);
        },
        {passive: true}
      );
      requestAnimationFrame(syncActiveAnchorFromScroll);
    }

    root.addEventListener('click', function (event) {
      var anchorButton = event.target.closest('[data-mobile-menu-anchor]');
      var tabButton = event.target.closest('[data-mobile-menu-tab]');

      if (anchorButton) {
        event.preventDefault();
        event.stopPropagation();

        var targetId = anchorButton.getAttribute('data-mobile-menu-anchor');
        var target = document.getElementById(targetId);

        if (!target || !scrollContainer) return;

        setActiveAnchor(anchorButton, true);

        var targetTop =
          target.getBoundingClientRect().top -
          scrollContainer.getBoundingClientRect().top +
          scrollContainer.scrollTop;

        scrollContainer.scrollTo({
          top: Math.max(0, targetTop - 8),
          behavior: 'smooth'
        });
        return;
      }

      if (tabButton && scrollContainer) {
        root.querySelectorAll('[data-mobile-menu-anchor].is-active').forEach(function (button) {
          button.classList.remove('is-active');
        });

        requestAnimationFrame(function () {
          scrollContainer.scrollTo({
            top: 0,
            behavior: 'auto'
          });
          requestAnimationFrame(syncActiveAnchorFromScroll);
        });
      }
    });
  }

  function initAllMobileMenuNavigation(context) {
    (context || document).querySelectorAll('[data-mobile-menu-tabs]').forEach(initMobileMenuNavigation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllMobileMenuNavigation(document);
    });
  } else {
    initAllMobileMenuNavigation(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllMobileMenuNavigation(event.target);
  });
})();



// 全局复制成功提示
(function () {
  if (window.GooGooShowCopySuccessToast) return;

  var TOAST_DURATION = 3000;
  var TOAST_SELECTOR = '[data-googoo-copy-success-toast]';
  var toast = null;
  var toastTimer = null;

  function addToastStyles() {
    if (document.querySelector('style[data-googoo-copy-success-toast-style]')) return;

    var style = document.createElement('style');
    style.setAttribute('data-googoo-copy-success-toast-style', '');
    style.textContent = `
      ${TOAST_SELECTOR} {
        align-items: center;
        background: #000000;
        border-radius: 90px;
        box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.08), 0 16px 24px 2px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.05);
        box-sizing: border-box;
        color: #ffffff;
        display: flex;
        gap: 6px;
        justify-content: center;
        left: 50%;
        max-width: calc(100vw - 32px);
        min-height: 48px;
        padding: 14px 16px;
        position: fixed;
        top: 30px;
        transform: translateX(-50%);
        z-index: 2147483647;
      }

      .googoo-copy-success-toast__icon {
        display: block;
        flex: 0 0 22px;
        height: 22px;
        line-height: 0;
        width: 22px;
      }

      .googoo-copy-success-toast__icon svg {
        display: block;
        height: 22px;
        width: 22px;
      }

      .googoo-copy-success-toast__text {
        color: #ffffff;
        font-family: Roboto, Arial, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
        white-space: nowrap;
      }
    `;
    document.head.appendChild(style);
  }

  function getToastHost() {
    var openDialogs = document.querySelectorAll('dialog[open]');

    if (openDialogs.length) {
      return openDialogs[openDialogs.length - 1];
    }

    return document.body || document.documentElement;
  }

  function createToast(host) {
    document.querySelectorAll(TOAST_SELECTOR).forEach(function (item) {
      item.remove();
    });

    var nextToast = document.createElement('div');
    nextToast.setAttribute('data-googoo-copy-success-toast', '');
    nextToast.setAttribute('role', 'status');
    nextToast.setAttribute('aria-live', 'polite');
    nextToast.innerHTML =
      '<span class="googoo-copy-success-toast__icon" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" focusable="false">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C17.0749 0 22 4.92506 22 11C22 17.0749 17.0749 22 11 22C4.92506 22 0 17.0779 0 11C0 4.92286 4.92506 0 11 0Z" fill="#28A12C"/>' +
      '<rect x="6.54688" y="9.53125" width="6.47059" height="1.94118" transform="rotate(45 6.54688 9.53125)" fill="white"/>' +
      '<rect x="8.37793" y="14.1172" width="10.3529" height="1.94118" transform="rotate(-45 8.37793 14.1172)" fill="white"/>' +
      '</svg>' +
      '</span>' +
      '<span class="googoo-copy-success-toast__text">Promo code copied!</span>';

    host.appendChild(nextToast);
    return nextToast;
  }

  function showCopySuccessToast() {
    addToastStyles();
    var host = getToastHost();

    if (!toast || !toast.isConnected) {
      toast = createToast(host);
    } else {
      if (toast.parentNode !== host) host.appendChild(toast);

      document.querySelectorAll(TOAST_SELECTOR).forEach(function (item) {
        if (item !== toast) item.remove();
      });
    }

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      if (toast && toast.isConnected) toast.remove();
      toast = null;
      toastTimer = null;
    }, TOAST_DURATION);
  }

  window.GooGooShowCopySuccessToast = showCopySuccessToast;
})();

// 折扣点击复制
(function () {
  if (window.GooGooProductDiscountCoupons) return;

  function fallbackCopy(text, onSuccess) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      onSuccess();
    } catch (error) {
      console.error('Copy discount code failed:', error);
    }

    textarea.remove();
  }

  function copyText(text, onSuccess) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(function () {
        fallbackCopy(text, onSuccess);
      });
      return;
    }

    fallbackCopy(text, onSuccess);
  }

  window.GooGooProductDiscountCoupons = function () {};

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-discount-copy-button]');
    if (!button) return;
    event.preventDefault();

    var code = button.dataset.code;

    if (!code) return;

    copyText(code, function () {
      window.GooGooShowCopySuccessToast();
    });
  });
})();

(function () {
  if (window.GooGooScreenScale) return;

  var DESIGN_WIDTH = 1920;
  var DESIGN_HEIGHT = 1080;
  var resizeTimer = null;

  function getScaleRatio() {
    var screen = document.querySelector('.container');
    var viewport = window.visualViewport;
    var rect = screen ? screen.getBoundingClientRect() : null;
    var viewportWidth = (rect && rect.width) || (viewport && viewport.width) || document.documentElement.clientWidth || window.innerWidth;
    var viewportHeight = (rect && rect.height) || (viewport && viewport.height) || document.documentElement.clientHeight || window.innerHeight;
    var widthRatio = viewportWidth / DESIGN_WIDTH;
    var heightRatio = viewportHeight / DESIGN_HEIGHT;

    return Math.min(widthRatio, heightRatio);
  }

  function updateScaleRatio() {
    var ratio = getScaleRatio();
    document.documentElement.style.setProperty('--scale-ratio', ratio.toFixed(4));

    return ratio;
  }

  function handleResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateScaleRatio, 120);
  }

  window.GooGooScreenScale = {
    getScaleRatio: getScaleRatio,
    updateScaleRatio: updateScaleRatio
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateScaleRatio, { once: true });
  } else {
    updateScaleRatio();
  }

  window.addEventListener('resize', handleResize);
  window.addEventListener('load', handleResize);
  window.addEventListener('orientationchange', handleResize);
  document.addEventListener('fullscreenchange', handleResize);
  document.addEventListener('webkitfullscreenchange', handleResize);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleResize);
  }
})();

class SizeGuidePageLoader extends HTMLElement {
  constructor() {
    super();
    this.loadContent = this.loadContent.bind(this);
  }

  connectedCallback() {
    if (this.dataset.sizeGuideReady === 'true') return;
    this.dataset.sizeGuideReady = 'true';

    var popup = this.closest('.size-guide');
    var trigger = popup && popup.querySelector('[data-popup-open]');

    if (trigger) {
      trigger.addEventListener('click', this.loadContent);
    } else {
      this.loadContent();
    }
  }

  disconnectedCallback() {
    var popup = this.closest('.size-guide');
    var trigger = popup && popup.querySelector('[data-popup-open]');

    if (trigger) {
      trigger.removeEventListener('click', this.loadContent);
    }
  }

  async loadContent() {
    if (this.dataset.sizeGuideLoaded === 'true' || this.dataset.sizeGuideLoading === 'true') {
      SizeGuidePageLoader.initTabs(this);
      return;
    }

    var url = this.dataset.pageUrl;
    if (!url) {
      this.innerHTML = '';
      return;
    }

    this.dataset.sizeGuideLoading = 'true';

    try {
      var response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Size guide page request failed');

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('[data-size-guide-page-content] [data-size-guide-tabs]');

      if (!content) {
        this.innerHTML = '';
        return;
      }

      var styles = Array.from(doc.querySelectorAll('[data-size-guide-page-content] style'));
      this.innerHTML = styles.map(function (style) {
        return style.outerHTML;
      }).join('') + content.outerHTML;

      this.dataset.sizeGuideLoaded = 'true';
      SizeGuidePageLoader.initTabs(this);
    } catch (error) {
      console.error('Size guide content failed to load:', error);
      this.removeAttribute('data-size-guide-loaded');
      this.innerHTML = '<p>Size guide content failed to load.</p>';
    } finally {
      this.removeAttribute('data-size-guide-loading');
    }
  }

  static initTabs(root) {
    root.querySelectorAll('[data-size-guide-tabs]:not([data-size-guide-tabs-ready])').forEach(function (tabsRoot) {
      tabsRoot.setAttribute('data-size-guide-tabs-ready', 'true');

      var tabs = tabsRoot.querySelectorAll('[data-size-guide-tab]');
      var panels = tabsRoot.querySelectorAll('[data-size-guide-panel]');
      var scrollable = tabsRoot.closest('size-guide-page-loader, .fixed-tab-contain');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-size-guide-tab');

          tabs.forEach(function (item) {
            var isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-size-guide-panel') === target);
          });

          if (scrollable) {
            scrollable.scrollTop = 0;
          }
        });
      });
    });
  }
}

if (!customElements.get('size-guide-page-loader')) {
  customElements.define('size-guide-page-loader', SizeGuidePageLoader);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    SizeGuidePageLoader.initTabs(document);
  });
} else {
  SizeGuidePageLoader.initTabs(document);
}

document.addEventListener('shopify:section:load', function (event) {
  SizeGuidePageLoader.initTabs(event.target);
});

// 倒计时
(function () {
  if (window.GooGooCartCountdown) return;

  function parseDate(value) {
    if (!value) return null;

    var raw = String(value).trim();
    var normalized = raw.indexOf('T') === -1 ? raw.replace(/\s+/, 'T') : raw;
    var timestamp = Date.parse(normalized);

    return Number.isFinite(timestamp) ? timestamp : null;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function render(root) {
    var endAt = parseDate(root.dataset.endTime);
    if (endAt === null) {
      root.hidden = true;
      return;
    }

    var remaining = endAt - Date.now();
    if (remaining <= 0) {
      root.hidden = true;
      if (root.cartCountdownInterval) {
        clearInterval(root.cartCountdownInterval);
      }
      return;
    }

    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    var daysEl = root.querySelector('[data-cart-countdown-days]');
    var hoursEl = root.querySelector('[data-cart-countdown-hours]');
    var minutesEl = root.querySelector('[data-cart-countdown-minutes]');
    var secondsEl = root.querySelector('[data-cart-countdown-seconds]');

    if (daysEl) daysEl.textContent = days;
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);

    root.hidden = false;
  }

  function init(root) {
    if (!root || root.dataset.cartCountdownReady === 'true') return;

    root.dataset.cartCountdownReady = 'true';
    render(root);
    root.cartCountdownInterval = setInterval(function () {
      render(root);
    }, 1000);
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-cart-countdown]').forEach(init);
  }

  window.GooGooCartCountdown = {
    init: init,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-cart-countdown]').forEach(function (root) {
      if (root.cartCountdownInterval) {
        clearInterval(root.cartCountdownInterval);
      }
    });
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.matches && node.matches('[data-cart-countdown]')) {
            init(node);
            return;
          }

          if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
